<script>
import { deviseDetailListMethods } from '@state/helpers/device-details'
import chartDateListRangeType from '@utils/chartDateListRangeType'
import cloneDeep from 'lodash/cloneDeep'
import { TIME_SELECT } from '@utils/constant'
import formatDate from '@/src/utils/format-date'
import coverChartData from '@utils/coverChartData'
import configChart from './configChart'
export default {
  page: {
    title: 'Device Detail',
    meta: [{ name: 'description', content: 'The Device Detail page.' }],
  },
  data() {
    return {
      chartData: null,
      endDate: null,
      TIME_SELECT: TIME_SELECT,
      nowDate: null,
      range: '1',
      title: '',
      configChart: [
        {
          label: '計測回数',
          key: 'used_times',
          config: cloneDeep(configChart[0]),
        },
        {
          label: '計測ユーザ数',
          key: 'used_members',
          config: cloneDeep(configChart[1]),
        },
      ],
      detailDeviceItem: [
        {
          label: 'アライアンス名',
          key: 'company',
          value: '',
        },
        {
          label: 'Macアドレス',
          key: 'mac',
          value: '',
        },
        { label: 'モデル名', key: 'model', value: '' },
        { label: 'デバイス名', key: 'device_name', value: '' },
        { label: '登録日時', key: 'created_at', value: '' },
        { label: '更新日時', key: 'updated_at', value: '' },
        {
          label: '最終計測日時',
          key: 'last_measure_time',
          value: '',
        },
        {
          label: '通算計測回数',
          key: 'mesure_count',
          value: '',
        },
        {
          label: '通算計測ユーザ数',
          key: 'mesure_unique_member',
          value: '',
        },
      ],
    }
  },
  computed: {
    chartDataComputed() {
      return this.handleGetChartData()
    },
  },
  created() {
    this.nowDate = formatDate(new Date())
    this.handledfetchChart()
    this.hanldGetDevice()
  },
  methods: {
    ...deviseDetailListMethods,
    async hanldGetDevice() {
      const response = await this.fetchDeviceById({
        id: parseInt(this.$route.params.id, 10),
      })

      if (response) {
        this.title = response.device_name
        this.detailDeviceItem = this.detailDeviceItem.map((item) => {
          item.value = response[item.key]
          return item
        })
      }
    },
    async handledfetchChart() {
      const response = await this.fetchingDeviceChart({
        device_id: parseInt(this.$route.params.id, 10),
        range_type: parseInt(this.range),
        end_date: this.nowDate,
      })
      if (response) {
        this.chartData = response.data
        this.startDate = response.data_start
        this.endDate = response.data_end
      }
    },
    handleGetChartData() {
      const chartData = this.configChart.map((item) => {
        item.config.data.labels = chartDateListRangeType(
          parseInt(this.range),
          this.startDate,
          this.endDate
        )
        const data = cloneDeep(this.chartData)?.map((v) => {
          return {
            x: v.label,
            y: v.values[item.key],
          }
        })

        item.config.data.datasets[0].data = coverChartData(
          data,
          item.config.data.labels
        )
        item.config.options.scales.xAxes[0].time.unit = 'day'
        item.config.options.scales.xAxes[0].ticks.source = 'labels'
        if (this.range === this.TIME_SELECT.week) {
          item.config.options.scales.xAxes[0].ticks.source = 'labels'
        } else if (this.range === this.TIME_SELECT.month) {
          item.config.options.scales.xAxes[0].ticks.source = 'labels'
          item.config.options.scales.xAxes[0].time.unit = 'month'
        }
        return item
      })
      return chartData
    },
    switchType(type) {
      this.range = type
      this.handledfetchChart()
    },
    fetchChart(date) {
      this.nowDate = date
      this.handledfetchChart()
    },
  },
}
</script>

<template>
  <div>
    <BaseCardDetail title="基本情報" form-collapsed>
      <template v-slot:header-action>
        <div />
      </template>
      <CContainer fluid>
        <CRow>
          <CCol
            v-for="(item, index) in detailDeviceItem"
            :key="index"
            sm="4"
            class="border border-bottom-0 border-left-0 border-right-0 pl-0"
          >
            <div class="d-flex align-items-center">
              <div class="w-50">{{ item.label }}</div>
              <BaseInput
                v-model="item.value"
                plaintext
                class="w-50 custom-height"
              />
            </div>
          </CCol>
        </CRow>
      </CContainer>
    </BaseCardDetail>
    <BaseCardDetail :title="title" form-collapsed>
      <template v-slot:header-action>
        <div />
      </template>
      <template>
        <div class="d-flex justify-content-end">
          <CButtonGroup>
            <CButton
              :class="{ active: range === TIME_SELECT.day }"
              color="dark"
              variant="outline"
              @click="switchType(TIME_SELECT.day)"
              >日</CButton
            >
            <CButton
              :class="{ active: range === TIME_SELECT.week }"
              color="dark"
              variant="outline"
              @click="switchType(TIME_SELECT.week)"
              >週</CButton
            >
            <CButton
              :class="{ active: range === TIME_SELECT.month }"
              color="dark"
              variant="outline"
              @click="switchType(TIME_SELECT.month)"
              >月</CButton
            >
          </CButtonGroup>
        </div>
        <div v-for="(chart, index) in chartDataComputed" :key="index">
          <div class="mx-5 mb-4">
            {{ chart.label }}
            <CChartLine
              class="mx-5 mt-3"
              style="height:300px"
              :labels="chart.config.data.labels"
              :datasets="chart.config.data.datasets"
              :options="chart.config.options"
            />
          </div>
        </div>
        <BaseSwitchTimeChart
          class="mx-5"
          :end-date="endDate"
          :range="range"
          @getDate="fetchChart"
        />
      </template>
    </BaseCardDetail>
  </div>
</template>

<style lang="scss" scoped>
.custom-height {
  height: 35px;
}
</style>
